import { createApp } from 'vue'

import App    from './App.vue'
import router from './router'
import './styles/index.css'
import { DOCUMENT_TITLE } from './branding'

document.title = DOCUMENT_TITLE

createApp(App).use(router).mount('#app')

// PWA install shell. The service worker is a no-op (see public/sw.js) — its
// only job today is to unlock the install prompt on platforms that require a
// registered SW. Skipped in dev so it cannot interfere with HMR or hold onto
// a stale bundle across restarts.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('[pwa] service worker registration failed', err)
    })
  })
}
